import React, { useCallback, useEffect } from 'react';

import { useWeb3React } from '@web3-react/core';
import { useDispatch, useSelector } from 'react-redux';
import { BrowserRouter as Router } from 'react-router-dom';

import { useAutoConnect } from './hooks';

import RouterPages from './pages';
import { setConnected, setUser } from './store/actions/user';
import { setContract, setTemplates } from './store/actions/contract';
import 'bootstrap/dist/css/bootstrap.min.css';
import { setTokens } from './store/actions/token';

function App() {
    const dispatch = useDispatch();
    const { user } = useSelector((state) => state.user);
    useAutoConnect();

    const { account } = useWeb3React();

    const checkUser = useCallback(
        (account) => {
            if (!account) {
                return;
            }
            dispatch(setUser(account));
        },
        [dispatch]
    );

    useEffect(() => {
        dispatch(setConnected(account));
        checkUser(account);
    }, [account, dispatch, checkUser]);

    useEffect(() => {
        if (user && user._id) {
            dispatch(setTemplates(user._id));
            dispatch(setContract(user._id));
            dispatch(setTokens(user._id));
        }
    }, [user, dispatch]);

    return (
        <Router>
            <RouterPages />
        </Router>
    );
}

export default App;
